// HistoryShareRedirect.jsx - Decode a short history slug and redirect to the
// full SharedChart view with query parameters.

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE } from "../../config/api";
import { httpRequest } from "../../utils/httpClient";

function HistoryShareRedirect() {
  const navigate = useNavigate();
  const { slug, range = "15", mode = "sessions" } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolve = async () => {
      try {
        const response = await httpRequest(`${API_BASE}/share/resolve/${slug}`, { method: "GET" });
        if (!response.ok) {
          setError("This share link is invalid or has expired.");
          return;
        }
        const data = await response.json();
        const params = new URLSearchParams({
          user: data.user_id,
          range,
          mode,
          type: "sessions-chart",
        });
        navigate(`/share/chart?${params.toString()}`, { replace: true });
      } catch (err) {
        setError("Unable to load this shared history.");
      }
    };
    resolve();
  }, [slug, range, mode, navigate]);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📊</div>
          <h2>History not found</h2>
          <p style={{ color: "var(--text-secondary, #666)" }}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>⏳</div>
        <div>Loading shared history…</div>
      </div>
    </div>
  );
}

export default HistoryShareRedirect;
